import { Text } from "react-native-paper";

export default function ErrorDetail({ children }: { children: string }) {
  return <Text variant="bodySmall">{children}</Text>;
}
